module.exports = __webpack_public_path__ + "img/thumbnail_PuffAdder_u_albino.951e1d53.png";